import "@fontsource/mulish";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Header from "./components/Header";
import Homepage from "./pages/index";
import { pageViewEvent } from "./services/adobeDataLayer";

import Thankyou from "./pages/thankyou";

function App() {
  //Trigger AA Page View Event
  useEffect(() => {
    pageViewEvent("landing page");
  }, []);

  return (
    <>
      <HelmetProvider>
        <Router basename={window.location.pathname}>
          <Header path="./dist/img/logo.webp" />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/thankyou" element={<Thankyou />} />
          </Routes>
        </Router>
      </HelmetProvider>
    </>
  );
}

export default App;
